import useMediaPrediction from './useMediaPrediction';

export const useButtonSizeBigger = () => {
  const lg = useMediaPrediction('(min-width: 1024px)');
  const md = useMediaPrediction('(min-width: 768px)');
  return lg ? 'bigger' : md ? 'big' : 'small';
};
export const useButtonSizeLarge = () => {
  const lg = useMediaPrediction('(min-width: 1024px)');
  const md = useMediaPrediction('(min-width: 768px)');
  return lg ? 'big' : md ? 'small' : 'smaller';
};

export const useButtonSizeSmall = () => {
  const lg = useMediaPrediction('(min-width: 1024px)');
  return lg ? 'big' : 'smaller';
};
export const useButtonSizeSmaller = () => {
  const md = useMediaPrediction('(min-width: 768px)');
  return md ? 'small' : 'smaller';
};
export const useButtonSizeMdSmaller = () => {
  const md = useMediaPrediction('(min-width: 1024px)');
  return md ? 'big' : 'smaller';
};
